/* SERTS */
export const GET_SERTS = "GET_SERTS"
export const GET_CLASS = "GET_CLASS"
export const GET_SERTS_SUCCESS = "GET_SERTS_SUCCESS"
export const GET_CLASS_SUCCESS = "GET_SERTS_SUCCESS"
export const GET_SERTS_FAIL = "GET_SERTS_FAIL"
export const GET_CLASS_FAIL = "GET_SERTS_FAIL"

/* SERTS PROFILE */
export const GET_SERT_PROFILE = "GET_SERT_PROFILE"
export const GET_SERT_PROFILE_SUCCESS = "GET_SERT_PROFILE_SUCCESS"
export const GET_SERT_PROFILE_FAIL = "GET_SERT_PROFILE_FAIL"

/**
 * add user
 */
export const ADD_NEW_SERT = "ADD_NEW_SERT"
export const ADD_SERT_SUCCESS = "ADD_SERT_SUCCESS"
export const ADD_SERT_FAIL = "ADD_SERT_FAIL"

/**
 * Edit user
 */
export const UPDATE_SERT = "UPDATE_SERT"
export const UPDATE_SERT_SUCCESS = "UPDATE_SERT_SUCCESS"
export const UPDATE_SERT_FAIL = "UPDATE_SERT_FAIL"

/**
 * Delete user
 */
export const DELETE_SERT = "DELETE_SERT"
export const DELETE_SERT_SUCCESS = "DELETE_SERT_SUCCESS"
export const DELETE_SERT_FAIL = "DELETE_SERT_FAIL"
